import api, { apiPrefix } from './Api';

export const getDailyProductsBanner = async (): Promise<string> => {
  const response = await api.get(`${apiPrefix}/daily-products`);

  return response.data?.data?.detail?.image_path ?? '';
};
